<template>
  <div class="container mt-6 mb-6 text-center">
    <h2 class="mb-3">Nuestro equipo</h2>
    <h5 class="font-weight-normal" style="margin-bottom: 100px !important">
      Un equipo de Talmidé Jajamim lleva adelante el proyecto Jabrutouch junto a
      un grupo de profesionales a cargo del desarrollo de la aplicación.
    </h5>
    <div class="row justify-content-center">
      <div class="col-lg-2 col-md-3 col-4 mb-5" v-for="person in equipo">
        <figure class="figure">
          <img
            :src="require('../assets/images/staff/' + person.avatar)"
            class="img-fluid"
          />
          <figcaption class="figure-caption mt-2">{{ person.name }}</figcaption>
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      equipo: [
        {
          name: "R. Yehoshua Benzadon",
          avatar: "R. Yehoshua Benzadon.png",
        },
        {
          name: "R. Daniel Nahon",
          avatar: "R. Daniel Nahon.png",
        },
        {
          name: "R. Tsvi Klor",
          avatar: "R. Zvi Klor.png",
        },
        {
          name: "R. Saadia Alfon",
          avatar: "R. Saadia Alfon.png",
        },
        {
          name: "R. Jacob Amar",
          avatar: "R. Yaacov Amar.png",
        },
        {
          name: "R. Shaul Benzadon",
          avatar: "R. Shaul Benzadon.png",
        },
        {
          name: "R. Jaim Sued",
          avatar: "R. Jaim Sued.png",
        },
        {
          name: "Sra. Aliza Verver",
          avatar: "Aliza Verver.png",
        },
        {
          name: "Ilan Rosenfeld",
          avatar: "Ilan Rosenfeld.png",
        },
        {
          name: "Alberto Hayón",
          avatar: "Alberto Hayon.png",
        },
      ],
    };
  },
};
</script>